export const API_CONFIG = {
  import: {
    base: ['commcode', 'VAT'],
    additionalCodes: ['taricAddCode1', 'taricAddCode2'],
    docCodes: Array.from({ length: 8 }, (_, i) => `docCode${i + 1}`),
    descriptions: Array.from({ length: 8 }, (_, i) => `description${i + 1}`),
  },
  export: {
    base: ['expCommodityCode'],
    additionalCodes: ['expTaricAddCode1', 'expTaricAddCode2'],
    docCodes: Array.from({ length: 6 }, (_, i) => `expDocCode${i + 1}`),
    descriptions: Array.from({ length: 6 }, (_, i) => `expDescription${i + 1}`),
  },
};

export const generateApiKeys = (commCode = '') => {
  const keys = {};
  const code = commCode;

  API_CONFIG.import.base.forEach((key) => {
    keys[key] = key === 'commcode' ? code : null;
  });
  API_CONFIG.import.additionalCodes.forEach((key) => {
    keys[key] = null;
  });
  API_CONFIG.import.docCodes.forEach((key) => {
    keys[key] = null;
  });
  API_CONFIG.import.descriptions.forEach((key) => {
    keys[key] = null;
  });

  API_CONFIG.export.base.forEach((key) => {
    keys[key] = key === 'expCommodityCode' ? code.substring(0, 8) : null;
  });
  API_CONFIG.export.additionalCodes.forEach((key) => {
    keys[key] = null;
  });
  API_CONFIG.export.docCodes.forEach((key) => {
    keys[key] = null;
  });
  API_CONFIG.export.descriptions.forEach((key) => {
    keys[key] = null;
  });

  return keys;
};

export const extractDataFromApi = (apiData, commCode, isImport = true) => {
  const config = isImport ? API_CONFIG.import : API_CONFIG.export;
  const defaultKeys = generateApiKeys(commCode);

  if (apiData && apiData.length > 0) {
    const data = apiData[0];
    const result = {};

    config.base.forEach((key) => {
      if (isImport && key === 'commcode') {
        result[key] = data.commodityCode || commCode;
      } else if (!isImport && key === 'expCommodityCode') {
        result[key] = data.expCommodityCode || commCode.substring(0, 8);
      } else {
        result[key] = data[key] || '';
      }
    });

    config.additionalCodes.forEach((key) => {
      result[key] = data[key] || '';
    });

    config.docCodes.forEach((key) => {
      result[key] = data[key] || '';
    });

    config.descriptions.forEach((key) => {
      result[key] = data[key] || '';
    });

    if (isImport && data.vatRates !== undefined) {
      result.VAT = data.vatRates || '';
    }

    return result;
  }

  const result = {};
  [...config.base, ...config.additionalCodes, ...config.docCodes, ...config.descriptions].forEach((key) => {
    result[key] = defaultKeys[key] || '';
  });
  if (isImport) {
    result.VAT = defaultKeys.VAT || '';
  }

  return result;
};

export const getDefaultFormValues = (commCode = '') => ({
  ...extractDataFromApi(null, commCode, true),
  ...extractDataFromApi(null, commCode, false),
});

export const cleanSavePayload = (formData) => {
  const baseKeys = generateApiKeys(formData.commcode);
  const saveData = {
    ...baseKeys,
    ...formData,
  };

  return Object.fromEntries(
    Object.entries(saveData).filter(([, value]) => value !== null && value !== '' && value !== undefined)
  );
};
